import { fetcher } from '@commenda/utils';
import {
  FilingSyncInProgressParams,
  FilingsSyncProgressResponse,
} from './types';

export async function fetchFilingSyncProgressStatus(
  corporationId: number,
  params?: FilingSyncInProgressParams
): Promise<{
  success: boolean;
  error?: string;
  data?: FilingsSyncProgressResponse['data'];
}> {
  try {
    // Validate that at least one of filing_id or both due dates is provided
    const hasFilingId = params?.filing_id !== undefined;
    const hasDateRange = params?.due_date_start && params?.due_date_end;
    const hasPartialDateRange =
      (params?.due_date_start || params?.due_date_end) && !hasDateRange;

    if (!hasFilingId && !hasDateRange) {
      return {
        success: false,
        error:
          'At least one of filing_id or both due_date_start and due_date_end must be provided',
      };
    }

    if (hasPartialDateRange) {
      return {
        success: false,
        error: 'Both due_date_start and due_date_end must be provided together',
      };
    }

    // Build query parameters
    const queryParams = new URLSearchParams();
    if (hasFilingId)
      queryParams.append('filing_id', params!.filing_id!.toString());
    if (hasDateRange) {
      queryParams.append('due_date_start', params!.due_date_start!);
      queryParams.append('due_date_end', params!.due_date_end!);
    }

    const url = queryParams.toString()
      ? `new-sales-tax/corporations/${corporationId}/filings/progress?${queryParams.toString()}`
      : `new-sales-tax/corporations/${corporationId}/filings/progress`;

    const response = await fetcher(url, { method: 'GET' }, undefined);

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to fetch filings progress',
      };
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to fetch filings progress';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
